import LSPMTable from "./LSPMTable";

export default LSPMTable;
